
import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Recommendation } from '@/types/assessment';
import QuestionRecommendationGroup from './QuestionRecommendationGroup';

interface CategoryRecommendationGroupProps {
  categoryName: string;
  questionGroups: Record<string, {
    questionText: string;
    recommendations: Recommendation[];
  }>;
  forceExpanded?: boolean;
}

const CategoryRecommendationGroup: React.FC<CategoryRecommendationGroupProps> = ({
  categoryName,
  questionGroups,
  forceExpanded = false
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  
  const totalRecommendations = Object.values(questionGroups).reduce(
    (sum, group) => sum + group.recommendations.length, 
    0
  );

  return (
    <div className="border rounded-lg bg-card">
      <button
        onClick={() => !forceExpanded && setIsExpanded(!isExpanded)}
        className="flex items-center gap-2 w-full text-left p-4 hover:bg-muted/50 rounded-lg"
        disabled={forceExpanded}
      >
        {(forceExpanded || isExpanded) ? (
          <ChevronDown className="h-5 w-5 text-muted-foreground" />
        ) : (
          <ChevronRight className="h-5 w-5 text-muted-foreground" />
        )}
        <span className="font-semibold">{categoryName}</span>
        <span className="text-sm text-muted-foreground ml-auto">
          ({totalRecommendations} recommendation{totalRecommendations !== 1 ? 's' : ''})
        </span>
      </button>
      
      {(forceExpanded || isExpanded) && (
        <div className="pb-4">
          {Object.entries(questionGroups).map(([questionId, group]) => (
            <QuestionRecommendationGroup
              key={questionId}
              questionText={group.questionText}
              recommendations={group.recommendations}
              forceExpanded={forceExpanded}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryRecommendationGroup;
